import React, {Fragment, useEffect, useState} from "react";

import {i18n} from "translate/i18n";

import {useNavigate, useParams} from "react-router";
import {Form, Field, Formik} from "formik";
import {toast} from "react-toastify";

import { getIndicatorByCode, setIndicators} from "services/Indicators.service";

import {useUser} from "store/providers/app";
import ModalComment from "components/Modal/modalComment";
import Editor from "components/Editor";
import {groupBy} from "utils/actions";
import {getCommentsById} from "services/Comments.service";
import Page from "../../../components/Page";
import {swalQuestion} from "../../../components/Swal";
import FormTableTranslate from "./form-table-translate";
import Loading from "../../../components/Loading";
import {uniqueId} from "lodash";
import Format from "../../../utils/format";
import PreviewTableTranslate from "../preview-table-translate";
import Steps from "../../../components/Steps";

const INITIAL_VALUES = {
    status: '',
    codigo: '',
    titulo: '',
    contexto: '',
    informacoes_complementares: '',
}

export default function FormTranslate() {

    let {code} = useParams();
    const {user} = useUser();

    const navigate = useNavigate();

    const [show, setShow] = useState(false)
    const [dataModal, setDataModal] = useState({})
    const [formValues, setFormValues] = useState(INITIAL_VALUES);
    const [comments, setComments] = useState([])
    const [dataPt, setDataPt] = useState([])
    const [loading, setLoading] = useState(true)
    const [tablesPT, setTablesPt] = useState([])

    useEffect(() => {
        const Request = async () => {
            const response = await getIndicatorByCode(code)

            const ptFilter = response.data.filter(indicator => indicator.language === 'pt-BR')
            const enFilter = response.data.filter(indicator => indicator.language === 'en-US')

            const pt = ptFilter[0]
            const en = enFilter[0]

            setTablesPt(pt?.tables)

            setDataPt({
                id: pt.id,
                codigo: pt.codigo,
                titulo: pt.titulo,
                contexto: pt.contexto ?? '',
                informacoes_complementares: pt.informacoes_complementares ?? '',
            })

            setFormValues(
                {
                    id: en.id,
                    statusDb: en.status,
                    codigo: en.codigo,
                    titulo: en.titulo,
                    contexto: en.contexto ?? '',
                    informacoes_complementares: en.informacoes_complementares ?? '',
                }
            )
            setLoading(false)
        }

        Request()
    }, [])

    useEffect(() => {
        const Request = async () => {

            const response = await getCommentsById(formValues.id)

            if (response) {
                let commentsIndicator = groupBy(response, 'type_input')

                commentsIndicator = {
                    ...commentsIndicator,
                    'total_context': commentsIndicator['context_en']?.filter(item => item.resolved === 0).length
                }
                commentsIndicator = {
                    ...commentsIndicator,
                    'total_info_complement': commentsIndicator['info_complement_en']?.filter(item => item.resolved === 0).length
                }

                setComments(commentsIndicator)
            }

        }

        Request()

    }, [formValues])

    const View = ({label, children}) => {
        return (
            <div className="form-group">
                <label className="form-label">{label}</label>
                {children}
            </div>
        )
    }

    const ViewButton = ({param, total, label, id}) => {
        return (
            <button type="button" className={`btn btn-primary position-relative py-3 ${!code && 'disabled'}`}
                    onClick={() => handleOpenModal(param, label, id)}>
                <i className="bi bi-chat-left-dots"/>
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {total ? total : 0}
                </span>
            </button>
        )
    }

    const handleOpenModal = (param, label, id) => {
        setDataModal({
            param,
            label,
            id
        })
        setShow(true)
    }

    const handleClose = () => {
        setShow(!show);
    }

    if (loading) {
         return <Loading />
    }

    return (
        <section className="content-wrapper mt-3 transition">
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">

                            <div className="">
                                <h2 className="text-uppercase fw-light"><i className="bi bi-translate text-theme"/> Tradutor</h2>
                            </div>

                            <ModalComment
                                show={show}
                                handleClose={handleClose}
                                data={dataModal}
                            />

                            <div className="row mt-4">
                                <div className="col-6">
                                    <ul className="nav nav-tabs mt-4 border-bottom-0" id="myTab" role="tablist">
                                        <li className="nav-item mt-2" role="presentation">
                                            <button className="nav-link border-0 shadow-sm active" id="indicatorPT-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#indicatorPT" type="button" role="tab" aria-controls="indicatorPT"
                                                    aria-selected="true">Indicador PT
                                            </button>
                                        </li>

                                        <li className="nav-item mt-2" role="presentation">
                                            <button className="nav-link border-0 shadow-sm" id="tablePT-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#tablePT" type="button" role="tab" aria-controls="tablePT"
                                                    aria-selected="true">Tabelas PT
                                            </button>
                                        </li>
                                    </ul>

                                    <div className="card rounded-0 rounded-bottom border-0 shadow-sm">
                                        <div className="card-body p-0">
                                            <div className="tab-content" id="myTabContent">

                                                <div className="tab-pane fade show active p-0" id="indicatorPT" role="tabpanel"
                                                     aria-labelledby="indicatorPT-tab">
                                                    <div className="p-3 d-grid gap-3">
                                                        <div className="row">
                                                            <div className="col-2">
                                                                <View label="Código">
                                                                    <input
                                                                        value={dataPt?.codigo}
                                                                        className="form-control"
                                                                        name="codigo"
                                                                        required
                                                                        disabled={true}
                                                                    />
                                                                </View>
                                                            </div>
                                                            <div className="col-10">
                                                                <View label={i18n.t('stage.title')}>
                                                                    <input
                                                                        value={dataPt?.titulo}
                                                                        className="form-control"
                                                                        name="titulo"
                                                                        required
                                                                        disabled={true}
                                                                    />
                                                                </View>
                                                            </div>
                                                        </div>

                                                        <div className="form-group mb-0">
                                                            <label className="form-label">{i18n.t('stage.context')}</label>
                                                            <Editor
                                                                handleChange={() => {}}
                                                                data={dataPt?.contexto}
                                                                name="contexto_en"
                                                                disabled={true}
                                                                lang="pt-BR"
                                                            />
                                                        </div>

                                                        <div className="form-group mb-0">
                                                            <label className="form-label">{i18n.t('stage.complements')}</label>
                                                            <Editor
                                                                handleChange={() => {}}
                                                                data={dataPt?.informacoes_complementares}
                                                                name="informacoes_complementares_en"
                                                                disabled={true}
                                                                lang="pt-BR"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="tab-pane fade p-3" id="tablePT" role="tabpanel"
                                                     aria-labelledby="tablePT-tab">

                                                    <PreviewTableTranslate tables={tablesPT} />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">

                                    <ul className="nav nav-tabs mt-4 border-bottom-0" id="myTab" role="tablist">
                                        <li className="nav-item mt-2" role="presentation">
                                            <button className="nav-link border-0 shadow-sm active" id="indicator-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#indicator" type="button" role="tab" aria-controls="indicator"
                                                    aria-selected="true">Indicador EN
                                            </button>
                                        </li>

                                        <li className="nav-item mt-2" role="presentation">
                                            <button className="nav-link border-0 shadow-sm" id="table-tab"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#table" type="button" role="tab" aria-controls="table"
                                                    aria-selected="true">Tabelas EN
                                            </button>
                                        </li>
                                    </ul>

                                    <div className="card rounded-0 rounded-bottom border-0 shadow-sm">
                                        <div className="card-body">
                                            <div className="tab-content" id="myTabContent">

                                                <div className="tab-pane fade show active p-0" id="indicator" role="tabpanel"
                                                     aria-labelledby="indicator-tab">

                                                    <Formik
                                                        initialValues={formValues}
                                                        enableReinitialize={true}
                                                        onSubmit={async (values) => {

                                                            const newData = {
                                                                codigo: values.codigo,
                                                                titulo: values.titulo,
                                                                contexto: values.contexto,
                                                                informacoes_complementares: values.informacoes_complementares,
                                                            }

                                                            swalQuestion(`${i18n.t('questions.editIndicator')} <b>${values.titulo}</b>?` ).then((result) => {
                                                                if (result.isConfirmed) {
                                                                    setIndicators(values.id, newData)
                                                                        .then((response) => {
                                                                            toast.success(i18n.t('success.editSuccessIndicator'))
                                                                        })
                                                                        .catch(() => toast.error(i18n.t('error.badRequest')))
                                                                }
                                                            })

                                                        }}
                                                    >
                                                        {({
                                                              values,
                                                              setFieldValue,
                                                          }) => (

                                                            <Form>
                                                                <div className="pt-4 px-3 d-grid gap-3">
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <Steps idDb={formValues.id} statusIndicator={formValues.statusDb} />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="px-3 d-grid gap-3">
                                                                    <div className="row">
                                                                        <div className="col-2">
                                                                            <View label="Código">
                                                                                <Field
                                                                                    className="form-control"
                                                                                    name="codigo"
                                                                                    required
                                                                                    disabled={true}
                                                                                />
                                                                            </View>
                                                                        </div>
                                                                        <div className="col-10">
                                                                            <View label={i18n.t('stage.title')}>
                                                                                <Field
                                                                                    className="form-control"
                                                                                    name="titulo"
                                                                                    required
                                                                                    disabled={user.profile === 3}
                                                                                />
                                                                            </View>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row align-items-end">
                                                                        <div className="col-12 col-md-11">
                                                                            <div className="form-group mb-0">
                                                                                <label className="form-label">{i18n.t('stage.context')}</label>
                                                                                <Editor
                                                                                    handleChange={setFieldValue}
                                                                                    data={values?.contexto}
                                                                                    name="contexto"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-12 col-md-1 d-grid">
                                                                            <ViewButton
                                                                                param="context_en"
                                                                                label="Contexto"
                                                                                total={comments?.total_context}
                                                                                id={values?.id}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="row align-items-end">
                                                                        <div className="col-12 col-md-11">
                                                                            <div className="form-group mb-0">
                                                                                <label className="form-label">{i18n.t('stage.complements')}</label>
                                                                                <Editor handleChange={setFieldValue}
                                                                                        data={values?.informacoes_complementares}
                                                                                        name="informacoes_complementares"/>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-12 col-md-1 d-grid">
                                                                            <ViewButton
                                                                                param="info_complement_en"
                                                                                label="Contexto"
                                                                                total={comments?.total_info_complement}
                                                                                id={values?.id}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                                {values.statusDb !== 'finished' &&
                                                                    <>
                                                                        <hr className="p-0"/>

                                                                        <div className="float-end pb-3 pe-3">
                                                                            <button className="btn btn-success px-5 py-2"
                                                                                    type="submit">{i18n.t('buttons.save')}</button>
                                                                        </div>
                                                                    </>
                                                                }

                                                            </Form>
                                                        )}
                                                    </Formik>

                                                </div>

                                                <div className="tab-pane fade p-0" id="table" role="tabpanel"
                                                     aria-labelledby="table-tab">
                                                    <FormTableTranslate id={formValues?.id} />
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
